import { gql } from '@apollo/client';

export const QUERY_ONBOARDING_STEP2 = gql`
  query onBoardingStep2 {
    step2 {
      data {
        attributes {
          content {
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
            button {
              text
              link
            }
          }
        }
      }
    }
  }
`;
